import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteCoupon, getVouchersList } from "../actions";
import { getVouchersFilter } from "../selectors";

export const useDeleteVoucher = ({ id }) => {
  const dispatch = useDispatch();
  const filter = useSelector(getVouchersFilter);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [deleteVoucherLoading, setDeleteVoucherLoading] = useState(false);

  const handleDeleteVoucher = async () => {
    setDeleteVoucherLoading(true);
    const is_success = await dispatch(deleteCoupon(id));
    setDeleteVoucherLoading(false);
    if (is_success) {
      dispatch(getVouchersList(filter));
      toggleModal();
    }
  };

  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  return {
    deleteVoucherLoading,
    handleDeleteVoucher,
    isOpenModal,
    toggleModal,
  };
};
